module.exports = __webpack_public_path__ + "static/media/share.6900e0b0.svg";